import { render } from "./subtareaCreate.vue?vue&type=template&id=6ce41c8d"
import script from "./subtareaCreate.vue?vue&type=script&lang=js"
export * from "./subtareaCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__